/** Fixed tax note on every document; it cannot be edited away. */
export const KLEINUNTERNEHMER_NOTE = "Der Rechnungsbetrag enthält gem. §6 Abs. 1 Z 27 UStG 1994 keine Umsatzsteuer";

/** Kleinunternehmer threshold (net per calendar year): warn from here … */
export const KU_WARN_CENTS = 4_500_000;
/** … and block above here unless explicitly overridden. */
export const KU_BLOCK_CENTS = 5_500_000;
/** Above this gross amount the recipient's UID number is required. */
export const UID_REQUIRED_ABOVE_CENTS = 1_000_000;

/** Pending approvals expire after 7 days. */
export const APPROVAL_TTL_MS = 7 * 24 * 60 * 60_000;

/** Refusal while INVOICING_FINALIZE_ENABLED is off. */
export const FINALIZE_DISABLED = "Festschreiben und Versenden sind bis zur Umstellung ausgeschaltet. Bis dahin vergibt sevDesk alle Nummern.";

/** An approved action whose document changed between the request and the executor's write. */
export const STALE_APPROVAL = "Das Dokument wurde seit der Anfrage geändert – bitte neu anfragen";

/** Retention period (BAO §132). */
export const ARCHIVE_YEARS = 7;

// Default texts; {zahlungsziel}, {nummer} and {gueltig_bis} are filled at render time.
export const DEFAULT_INVOICE_INTRO = "Sehr geehrte Damen und Herren,\n\nvielen Dank für Ihren Auftrag und das damit verbundene Vertrauen!\nHiermit stelle ich Ihnen die folgenden Leistungen in Rechnung:";
export const DEFAULT_INVOICE_CLOSING = "Zahlungsbedingungen: Zahlung innerhalb von {zahlungsziel} Tagen ab Rechnungseingang ohne Abzüge.\n\nBitte überweisen Sie den Rechnungsbetrag unter Angabe der Rechnungsnummer {nummer} auf das unten angegebene Konto.\n\nMit freundlichen Grüßen\nFlorian Böhler";
export const DEFAULT_OFFER_INTRO = "Sehr geehrte Damen und Herren,\n\nvielen Dank für Ihr Interesse. Gerne biete ich Ihnen die folgenden Leistungen an:";
export const DEFAULT_OFFER_CLOSING = "Dieses Angebot ist gültig bis {gueltig_bis}.\n\nMit freundlichen Grüßen\nFlorian Böhler";
